import React from "react";
import Header from "../../components/orrbiitheader";
import Footer from "../../components/footerorrbiit";

export default function PrivacyPolicy() {
  return (
    <>
      <Header />

      <style>{`
        .privacy-wrapper{
          background:#f7ead7;
          min-height:100vh;
          padding:25px 0;
        }

        .privacy-container{
          max-width:850px;
          margin:auto;
          line-height:1.6;
          color:#444;
        }

        .privacy-title{
          text-align:center;
          margin-bottom:12px;
        }

        .privacy-title h1{
          font-weight:800;
          margin-bottom:4px;
        }

        .privacy-section{
          margin-bottom:16px;
        }

        .privacy-section h3{
          margin:0 0 6px 0;
          font-size:18px;
        }

        .privacy-section p{
          margin:0;
        }
      `}</style>

      <div className="privacy-wrapper">
        <div className="privacy-container">

          {/* TITLE */}
          <div className="privacy-title">
            <h1>Privacy Policy</h1>
            <p style={{ fontWeight: "600" }}>ORRBIIT GROUP</p>
            <p style={{ fontSize: "12px", color: "#777" }}>
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          {/* INTRO */}
          <div className="privacy-section">
            <p>
              This Privacy Policy describes how Orrbiit Group collects, uses, and protects
              user information across all its services, including Orrbiit Elegance,
              Orrbiit Go, and Orrbiit Relief. By accessing or using our services, you agree
              to the practices described in this policy.
            </p>
          </div>

          {/* DATA COLLECTION */}
          <div className="privacy-section">
            <h3>Information We Collect</h3>
            <p>
              We may collect personal information such as your name, phone number, email address,
              location, and booking details when you interact with our platform. This information
              is collected when you make a booking, contact us, or use our services.
            </p>
          </div>

          {/* USAGE */}
          <div className="privacy-section">
            <h3>How We Use Your Information</h3>
            <p>
              Your information is used to process bookings, provide services, communicate with you,
              improve our offerings, and ensure a smooth and reliable user experience. We may also
              use your information for customer support and service optimization.
            </p>
          </div>

          {/* SHARING */}
          <div className="privacy-section">
            <h3>Sharing of Information</h3>
            <p>
              Orrbiit does not sell, rent, or trade your personal information. Your data may be shared
              with our team members, service providers, or trusted partners only when necessary to
              deliver services effectively.
            </p>
          </div>

          {/* PAYMENT */}
          <div className="privacy-section">
            <h3>Payment Information</h3>
            <p>
              Payments are processed through secure third-party payment gateways. Orrbiit does not
              store sensitive financial information such as debit/credit card details. All payment
              transactions are handled in accordance with the policies of the respective payment providers.
            </p>
          </div>

          {/* DATA RETENTION */}
          <div className="privacy-section">
            <h3>Data Retention</h3>
            <p>
              We retain user information only for as long as necessary to provide services, resolve
              disputes, and comply with legal obligations. Data may be securely deleted when no longer required.
            </p>
          </div>

          {/* SECURITY */}
          <div className="privacy-section">
            <h3>Data Security</h3>
            <p>
              We implement reasonable security measures to protect your information from unauthorized access,
              misuse, or disclosure. However, no digital system is completely secure, and we cannot guarantee
              absolute protection.
            </p>
          </div>

          {/* COOKIES */}
          <div className="privacy-section">
            <h3>Cookies & Tracking</h3>
            <p>
              Our platform may use cookies and similar technologies to improve user experience,
              analyze usage patterns, and enhance functionality.
            </p>
          </div>

          {/* USER RIGHTS */}
          <div className="privacy-section">
            <h3>User Rights</h3>
            <p>
              Users have the right to request correction or deletion of their personal information.
              Such requests can be made by contacting us through our official communication channels.
            </p>
          </div>

          {/* THIRD PARTY */}
          <div className="privacy-section">
            <h3>Third-Party Services</h3>
            <p>
              Some services, including payments and external integrations, may involve third-party
              providers. These providers operate under their own privacy policies, and Orrbiit is not
              responsible for their data practices.
            </p>
          </div>

          {/* LEGAL */}
          <div className="privacy-section">
            <h3>Legal Compliance</h3>
            <p>
              We may disclose user information if required by law or in response to valid legal requests,
              including compliance with government or regulatory authorities.
            </p>
          </div>

          {/* ALL SERVICES */}
          <div className="privacy-section">
            <h3>Applies to All Orrbiit Services</h3>
            <p>
              This Privacy Policy applies to all services operated under Orrbiit Group, including
              Orrbiit Elegance, Orrbiit Go, and Orrbiit Relief, unless stated otherwise.
            </p>
          </div>

          {/* CHANGES */}
          <div className="privacy-section">
            <h3>Changes to This Policy</h3>
            <p>
              Orrbiit reserves the right to update or modify this Privacy Policy at any time.
              Continued use of our services indicates acceptance of the updated policy.
            </p>
          </div>

          {/* CONTACT */}
          <div className="privacy-section">
            <h3>Contact Us</h3>
            <p>
              For any questions regarding this Privacy Policy, please contact us:<br />
              Email: info@orbiit.com<br />
              Phone: +91 9836904698
            </p>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}